<template>
  <div class="highschool-container">
    <div class="highschool-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/highschool-banner.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">高校图书馆特色方案</h2>
          <p class="banner-desc" style="width:29.4rem">
            博库高校图书馆特色方案为高校提供了不同场景线下泛在
            阅读服务和线上云端图书馆平台服务，以及更具特色的考研场景设计，阅读大数据分析等，大大增强了学生对图书馆的粘性，以及图书馆的服务水平。
          </p>
        </div>
      </div>
    </div>
    <!-- 线下泛在服务 -->
    <div class="highschool-container-offline">
      <h2 class="highschool-container-offline-title title-common">
        线下泛在服务
      </h2>
      <!-- <img
        src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-index-offline.png"
        alt=""
      /> -->
      <div class="highschool-container-offline-content">
        <div class="highschool-container-offline-content-left">
          <div class="highschool-container-offline-content-left-sushe clear">
            <div class="text">
              <h2>宿舍</h2>
              <p>智能预借取书柜</p>
            </div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-sushe.png"
              alt=""
            />
          </div>

          <img
            src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-lefticon.png"
            alt=""
            style="width:22.3125rem;height:6rem"
          />
          <div class="highschool-container-offline-content-left-teach clear">
            <div class="text">
              <h2>教学楼</h2>
              <p>智能借还柜</p>
            </div>

            <img
              src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-teach.png"
              alt=""
            />
          </div>

          <img
            src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-lefticon.png"
            alt=""
            style="width:22.3125rem;height:6rem"
          />
        </div>
        <div class="highschool-container-offline-content-center">
          <img
            src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-bg.png"
            alt=""
          />
          <div class="highschool-container-offline-content-center-desc">
            <p>在教学楼、宿舍、食堂、校门和校园公共活动区</p>
            <p>建设开放性借阅空间</p>
            <p>学生不用去图书馆，随时就地借还图书</p>
            <p>为学校师生提供“随手可及、随处可读”泛在阅读服务</p>
          </div>
        </div>
        <div class="highschool-container-offline-content-right">
          <div class="highschool-container-offline-content-right-shitang">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-shitang.png"
              alt=""
            />
            <div class="text">
              <h2>食堂</h2>
              <p>智能借还柜</p>
            </div>
          </div>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-righticon.png"
            alt=""
            style="width:22.3125rem;height:6rem"
          />
          <div class="highschool-container-offline-content-right-lib">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-lib.png"
              alt=""
            />
            <div class="text">
              <h2>图书馆</h2>
              <p>24小时自助还书柜</p>
            </div>
          </div>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-righticon.png"
            alt=""
            style="width:22.3125rem;height:6rem"
          />
        </div>
      </div>
    </div>
    <!-- 线上泛在图书馆平台 -->
    <div class="highschool-container-online">
      <h2 class="highschool-container-online-title title-common">
        线上泛在图书馆平台
      </h2>
      <div class="highschool-container-online-pic">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-platform-fix.png"
          alt=""
        />
        <ul class="highschool-container-online-pic-hidden">
          <li v-for="(item, i) in 3" :key="i" @click="handleChange(i)"></li>
        </ul>
        <div
          class="highschool-container-online-pic-desc"
          :class="[
            { isActive0: current == 0 },
            { isActive1: current == 1 },
            { isActive2: current == 2 },
          ]"
        >
          {{ desc }}
        </div>
      </div>
    </div>
    <!-- 全预约式图书馆 -->
    <div class="highschool-container-reservation">
      <h2 class="highschool-container-reservation-title title-common">
        全预约式图书馆
      </h2>
      <div class="highschool-container-reservation-content">
        <ul class="highschool-container-reservation-content-list">
          <li
            v-for="(item, i) in reserveList"
            :key="i"
            @mouseover="handleHover(i)"
          >
            <img :src="item.pic" alt="" />
            <p>{{ item.title }}</p>
            <div
              class="bubble-box"
              :class="{ alignCenter: curr == 1 }"
              v-if="curr == i"
              v-html="item.desc"
            ></div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 考研专区 -->
    <div class="highschool-container-kaoyan">
      <h2 class="highschool-container-kaoyan-title title-common">
        考研专区
      </h2>
      <div class="highschool-container-kaoyan-subtitle">
        <p>考研专区是专门为高校图书馆设计的场景化解决方案</p>
        <p>为高校图书馆提供智能化的考研资源管理平台</p>
      </div>
      <div class="highschool-container-kaoyan-img">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/highschool/highschool-kaoyan-fix.png"
          alt=""
        />
      </div>
      <p class="title1">考研专区座位智能分配系统</p>
      <p class="title2">智能闸机人流管控系统</p>
      <p class="title3">考研专区存包柜智能分配系统</p>
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      current: 0,
      curr: 0,
      desc:
        "学生完成一定的阅读任务，即可参加阅读学分考试，考核合格后可获得相应学分，并计入学生总学分。 平台能够实现学校“阅读积分制”信息化建设，同时引导学生阅读，形成良好的阅读习惯。",
      reserveList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/highschool/highschool-list-item1.png",
          title: "约书",
          desc: "· 微信智能预约取书 <br /> · 馆外转借",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/highschool/highschool-list-item2.png",
          title: "约地",
          desc: "· 空间预约<br /> · 座位预约<br /> · 到馆预约",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/highschool/highschool-list-item3.png",
          title: "约事",
          desc: "· 讲座、培训、沙龙观影 等活动的预约",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/highschool/highschool-list-item4.png",
          title: "约人",
          desc: "· 约同学、好友线上共读 一本书",
        },
      ],
    };
  },
  methods: {
    handleChange(i) {
      this.current = i;
      switch (i) {
        case 0:
          this.desc =
            "学生完成一定的阅读任务，即可参加阅读学分考试，考核合格后可获得相应学分，并计入学生总学分。 平台能够实现学校“阅读积分制”信息化建设，同时引导学生阅读，形成良好的阅读习惯。";
          break;
        case 1:
          this.desc =
            "平台提供个性化的读者阅读书籍统计定制服务，对读者的阅读行为和阅读偏好进行多维度统计和分析， 生成个性化的阅读报告。";
          break;
        case 2:
          this.desc =
            "馆方通过微信图书馆公众号，在手机端可对图书馆新用户进行入馆教育、基本知识培训，并能对培训 后的内容进行考核，保证读者掌握图书的使用规范。";
          break;
        default:
          break;
      }
    },
    handleHover(i) {
      this.curr = i;
      console.log(i);
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libHighschool.scss";
</style>
